(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lp-campaign"] && !Shopify.designMode) return;
  try {
    
(function () {
  var MOBILE = '(max-width: 767px)';

  function initVideo(holder) {
    if (holder.dataset.lpcInit) return;
    var isMobile = window.matchMedia(MOBILE).matches;
    var src = isMobile ? holder.dataset.mobile : holder.dataset.desktop;
    if (!src) src = holder.dataset.desktop || holder.dataset.mobile;
    if (!src) return;
    holder.dataset.lpcInit = '1';

    var v = document.createElement('video');
    v.muted = true;
    v.defaultMuted = true;
    v.loop = true;
    v.playsInline = true;
    v.setAttribute('playsinline', '');
    v.setAttribute('muted', '');
    v.setAttribute('aria-hidden', 'true');
    v.preload = 'auto';
    v.src = src;
    v.addEventListener('canplay', function () {
      holder.classList.add('is-ready');
      var p = v.play();
      if (p && p.catch) p.catch(function () { holder.classList.remove('is-ready'); });
    }, { once: true });
    holder.appendChild(v);
  }

  function boot() {
    // Motion is opt-out for reduced-motion and data-saver users.
    var allowMotion = !window.matchMedia('(prefers-reduced-motion: reduce)').matches &&
                      !(navigator.connection && navigator.connection.saveData);
    if (allowMotion) {
      // The hero starts once the page has settled, so its poster stays the LCP.
      document.querySelectorAll('.lpc-hero [data-lpc-video]').forEach(initVideo);

      // Banner and split videos wait until they are nearly on screen, so a page
      // with several of them does not download them all up front.
      var lazy = document.querySelectorAll('.lpc-banner [data-lpc-video], .lpc-split [data-lpc-video], .lpc-feature [data-lpc-video]');
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { initVideo(e.target); io.unobserve(e.target); }
          });
        }, { rootMargin: '200px 0px' });
        lazy.forEach(function (el) { io.observe(el); });
      } else {
        lazy.forEach(initVideo);
      }
    }

    // click-to-play lookbook tiles: cover image fades out, video takes the box
    document.querySelectorAll('[data-lpc-tile-play]').forEach(function (btn) {
      if (btn.dataset.lpcBound) return;
      btn.dataset.lpcBound = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var media = btn.closest('.lpc-tile__media');
        var tpl = media && media.querySelector('[data-lpc-tile-video]');
        if (!tpl) return;
        media.appendChild(tpl.content.cloneNode(true));
        var vid = media.querySelector('video');
        media.classList.add('is-playing');
        if (vid) {
          vid.setAttribute('playsinline', '');
          vid.playsInline = true;
          var pr = vid.play();
          if (pr && pr.catch) pr.catch(function () {});
        }
        btn.remove();
      });
    });

    // rolling strip: clone the slides until they overflow twice, then translate
    // the track by half its width so the loop is seamless.
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('[data-lpc-marquee]').forEach(function (vp) {
      if (vp.dataset.lpcInit) return;
      var track = vp.querySelector('.lpc-marquee__track');
      if (!track || !track.children.length) return;
      vp.dataset.lpcInit = '1';
      // Static strips and reduced-motion users get a plain swipeable row:
      // no cloning, no animation.
      if (reduce || vp.classList.contains('lpc-marquee--static')) return;

      var originals = Array.prototype.slice.call(track.children);
      var guard = 0;
      while (track.scrollWidth < vp.offsetWidth * 2 && guard < 12) {
        originals.forEach(function (n) {
          var c = n.cloneNode(true);
          c.setAttribute('aria-hidden', 'true');
          track.appendChild(c);
        });
        guard++;
      }
      Array.prototype.slice.call(track.children).forEach(function (n) {
        var c = n.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        track.appendChild(c);
      });

      var speed = parseFloat(vp.dataset.speed) || 60;
      var half = track.scrollWidth / 2;
      track.style.setProperty('--lpc-mq-dur', (half / speed).toFixed(1) + 's');
      vp.classList.add('is-running');
    });

    // rail arrows
    document.querySelectorAll('[data-lpc-rail-nav]').forEach(function (nav) {
      var section = nav.closest('.lpc-shop');
      var rail = section && section.querySelector('[data-lpc-rail]');
      if (!rail) return;
      nav.querySelectorAll('[data-dir]').forEach(function (b) {
        if (b.dataset.lpcBound) return;
        b.dataset.lpcBound = '1';
        b.addEventListener('click', function () {
          var card = rail.querySelector('.lpc-card');
          var step = card ? card.getBoundingClientRect().width + 16 : 316;
          rail.scrollBy({ left: step * parseInt(b.dataset.dir, 10), behavior: 'smooth' });
        });
      });
    });
  }

  if (document.readyState === 'complete') { boot(); }
  else { window.addEventListener('load', boot); }

  // theme editor support
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:block:select', boot);
})();

  } catch(e) { console.error(e); }
})();
})();
